import { render, staticRenderFns } from "./SponsoredPill.vue?vue&type=template&id=4474b534&scoped=true"
import script from "./SponsoredPill.vue?vue&type=script&lang=ts&setup=true"
export * from "./SponsoredPill.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SponsoredPill.vue?vue&type=style&index=0&id=4474b534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474b534",
  null
  
)

export default component.exports